// ==========================================
// PROPERTYCARD.JSX - PROPERTY CARD COMPONENT
// ==========================================

import React, { useContext, useState } from "react";
import {
  FaMapMarkerAlt,
  FaArrowRight,
  FaHeart,
  FaRegHeart,
} from "react-icons/fa";
import "../../../../assets/css/Buyer/Properties/PropertyCards.css"; // CSS file import
import { useNavigate } from "react-router-dom";
import AppContext from "context/AppContext";
import axios from "axios";

function PropertyCards({ property, wishlistId, onDelete, showDelete = false }) {
  const navigate = useNavigate();
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================

  // Hover state - show info overlay on hover
  const { baseUrl, baseUrlForFiles, authToken } = useContext(AppContext);

  const [isHovered, setIsHovered] = useState(false);

  // ==========================================
  // HANDLER FUNCTIONS
  // ==========================================

  const handleViewDetails = () => {
    axios.post(`${baseUrl}/buyer/property/increasePropertyView`, {
      id: property?.id,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    // Clicks Increase
    axios
      .post(`${baseUrl}/buyer/property/increasePropertyClick`, {
        id: property?.id,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        // View count increase hone ke baad detail page open karo
        navigate(`/property/${property?.id}`);
      })
      .catch((error) => {
        console.log("Error increasing property view:", error);

        // Agar API fail bhi ho to user ko detail page par bhej do
        navigate(`/property/${property?.id}`);
      });
  };

  // Handle next arrow click (for image carousel if multiple images)
  const handleNextImage = (e) => {
    e.stopPropagation(); // Prevent card click
    console.log("Next image for property:", property?.id);
    // Add image carousel logic here if needed
  };

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <div
      className="property-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* ==========================================
          DEFAULT STATE - Property Image with Basic Info
          ========================================== */}
      <div className={`card-default ${isHovered ? "hidden" : "visible"}`}>
        {/* Background Image */}
        <div
          className="card-image"
          style={{
            backgroundImage: `url(${baseUrlForFiles}${property?.expropertyimages[0]?.images})`,
          }}
        >
          {/* Dark Overlay */}
          <div className="card-overlay" />

          {/* Buy/Rent Badge - Top Right Corner 
          <div className={`listing-badge ${property?.listingType?.toLowerCase()}`}>
            {property?.listingType}
          </div>*/}

          {/* Location Badge - Top Left */}
          <div className="location-badge">
            <FaMapMarkerAlt className="location-icon" />
            <span>{property?.location}</span>
          </div>

          {/* Bottom Content - Number & Title */}
          <div className="card-bottom-content">
            <div className="property-number">{property?.number}</div>
            <h3 className="property-titles">{property?.property_title}</h3>
          </div>
        </div>
      </div>

      {/* ==========================================
          HOVER STATE - Property Details Overlay
          ========================================== */}
      <div className={`card-hover ${isHovered ? "visible" : "hidden"}`}>
        {/* Top Info Row */}
        <div className="hover-top-row">
          <div className="hover-left">
            <span className="hover-number">{property?.number}</span>
            <div className="hover-location">
              <FaMapMarkerAlt className="hover-location-icon" />
              <span>{property?.location}</span>
            </div>
            <span className="hover-type">{property?.listingType}</span>
          </div>
          <div className="hover-price">{property?.price}</div>
        </div>

        {/* Developer Info */}
        <p className="hover-developer"> {property?.property_title}</p>

        {/* Property Title */}
        <h3 className="hover-title">{property?.property?.title}</h3>

        {/* Action Buttons */}
        <div className="property-card-actions">
          {/* View Details Button */}
          <button className="view-details-btn" onClick={handleViewDetails}>
            View Details
          </button>

          {/* Delete Button - Sirf BuyerProperty mein show hoga */}
          {showDelete && (
            <button
              className="delete-property-btn"
              onClick={() => onDelete(wishlistId)}
            >
              Delete
            </button>
          )}
        </div>
        {/* Property Detail Image */}
        <div className="hover-image-container">
          <img
            src={`${baseUrlForFiles}${property?.expropertyimages[0]?.images}`}
            alt={property?.title}
            className="hover-image"
          />
        </div>
      </div>
    </div>
  );
}

export default PropertyCards;
